import { useEffect, useState, type ComponentType } from 'react';
import LegacyEntry from './LegacyEntry';
import Landing from './landing/Landing';
import { AppLoading } from './AppLoading';
import { authTimeout, useLandingRoute } from './site-route';

export default function SiteEntry() {
  const [landing] = useLandingRoute();
  const [config, setConfig] = useState<{ appId: string | null }>();
  const [Entry, setEntry] = useState<ComponentType<{ appId: string }>>();
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError('');
    void (async () => {
      try {
        const response = await fetch('/api/auth/config', {
          cache: 'no-store',
          signal: AbortSignal.any([
            controller.signal,
            AbortSignal.timeout(10000),
          ]),
        });
        if (!response.ok) throw Error();
        const body = await response.json();
        if (
          body.appId !== null &&
          (typeof body.appId !== 'string' || !body.appId.trim())
        )
          throw Error();
        if (body.appId) {
          const module = await authTimeout(import('./auth/AuthSite'));
          if (controller.signal.aborted) return;
          setEntry(() => module.default);
        }
        if (!controller.signal.aborted) setConfig(body);
      } catch {
        if (!controller.signal.aborted)
          setError('Sign-in could not load. Please try again.');
      }
    })();
    return () => controller.abort();
  }, [attempt]);
  if (config?.appId && Entry) return <Entry appId={config.appId} />;
  if (config?.appId === null) return <LegacyEntry />;
  if (!landing)
    return (
      <AppLoading error={error} onRetry={() => setAttempt((n) => n + 1)} />
    );
  return (
    <Landing
      busy={!error}
      message={error || 'Preparing sign-in…'}
      onEnterApp={(event) => {
        event.preventDefault();
        if (error) setAttempt((n) => n + 1);
      }}
    />
  );
}
